// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1pTJ_","head":"Table_head__OH5lP","col":"Table_col__28ebW"};